import { useState, useRef, useEffect } from 'react';

import {
  Box,
  ButtonGroup,
  Fade,
  Flex,
  IconButtonGroup,
  SearchIcon,
} from '@frontend/components';

import HeaderIconButton from 'components/HeaderIconButton/HeaderIconButton';

import HelpMode from 'modules/common/helpMode/HelpMode';
import NotificationsPopover from 'modules/notifications/NotificationsPopover';
import { SearchBar } from 'modules/search/SearchBar';
import { SearchDataContextProvider } from 'modules/search/context';

import DesktopTabs from './components/DesktopTabs';
import HomeNav from './components/HomeNav';
import NavDropdown from './components/NavDropDown';

export const Nav = () => {
  const [searchBarIsActive, setSearchBarIsActive] = useState<boolean>(false);

  const searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (searchBarIsActive) {
      searchInputRef.current?.focus();
    }
  }, [searchBarIsActive]);

  return (
    <Box
      bg="brand.primary"
      display="flex"
      minHeight={8}
      transition="all 0.2s ease"
    >
      <Box
        display={{
          base: searchBarIsActive ? 'none' : 'flex',
          tablet: 'flex',
        }}
        flex="0 0 auto"
        flexDirection="column"
        justifyContent="center"
      >
        <HomeNav />
      </Box>
      <Box
        flexDirection="column"
        justifyContent="center"
        height="100%"
        p={0}
        m="auto 0"
        flex="0 1 auto"
        maxWidth={searchBarIsActive ? 'unset' : '240px'}
        minWidth={searchBarIsActive ? 'unset' : 0}
        display={{
          base: searchBarIsActive ? 'flex' : 'none',
          desktop: 'flex',
        }}
      >
        <SearchDataContextProvider>
          <SearchBar
            isActive={searchBarIsActive}
            setIsActive={setSearchBarIsActive}
            searchInputRef={searchInputRef}
          />
        </SearchDataContextProvider>
      </Box>
      <Fade in={!searchBarIsActive}>
        <DesktopTabs />
      </Fade>
      <Flex flexGrow={1} />
      <Fade in={!searchBarIsActive}>
        <Flex height="100%">
          <IconButtonGroup
            as={ButtonGroup}
            size="lg"
            spacing={0}
            display="flex"
            alignItems="center"
          >
            <HeaderIconButton
              onClick={() => setSearchBarIsActive(true)}
              display={{
                tablet: 'unset',
                desktop: 'none',
              }}
            >
              <SearchIcon size={4} />
            </HeaderIconButton>
            <HelpMode />
            <NotificationsPopover />
          </IconButtonGroup>
          <NavDropdown />
        </Flex>
      </Fade>
    </Box>
  );
};
